































































































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { trim } from '@/utils/validators';
// axios请求
import { addOrEditSentry } from '@/api/parking-lot-management/index';

// form表单项定义
export interface IForm {
  realName: string;
  parkId: string;
  username: string;
  mobile: string;
  email: string;
  password: string;
  enabled: string;
  passwordTwo: string;
}

@Component({
  components: { ParkingLotSearch }
})
export default class AddEditArea extends Vue {
  @Prop({ default: () => {} })
  dataForm!: any;

  @Prop()
  parkId!: string;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  id = '';
  enabled = true;
  // 表单
  form: any = null;
  validatorsTrim = trim;
  spinning: boolean = false;
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.init();
    this.enabled = val.enabled;
  }

  // 是否是禁用
  get isParkdisabledFlag() {
    return this.isParkDisabled;
  }

  // 生命周期初始化
  created() {
    this.id = this.$route.params.id;
    this.init();
  }

  // 初始化form表单
  init() {
    if (this.isEdit && this.dataForm) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { realName, username, mobile, email, password, enabled, parkId, passwordTwo } = this.dataForm;
          return {
            realName: this.$form.createFormField({
              value: realName
            }),
            username: this.$form.createFormField({
              value: username
            }),
            mobile: this.$form.createFormField({
              value: mobile
            }),
            email: this.$form.createFormField({
              value: email
            }),
            parkId: this.$form.createFormField({
              value: parkId
            }),
            password: this.$form.createFormField({
              value: password
            }),
            passwordTwo: this.$form.createFormField({
              value: passwordTwo
            }),
            enabled: this.$form.createFormField({
              value: enabled
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this);
    }
  }

  // 提交监听处理
  async handleSubmit(e: any) {
    // console.log(e)
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        // debugger;
        if (!this.isEdit) {
          if (values.password !== values.passwordTwo) {
            return this.$message.warning('两次密码不一致');
          }
        }

        // 状态 00禁用  01启用
        values.enabled = this.enabled ? '01' : '00';
        this.onAddOrEdit({ ...values });
      }
    });
  }
  // 提交请求发送添加

  // 添加和编辑
  async onAddOrEdit(values: IForm) {
    // TIP: 和后端沟通接口返回ID给前端
    if (this.spinning) return;
    this.spinning = true;
    try {
      const res = await addOrEditSentry({
        ...values,
        ...(this.isEdit ? { id: this.dataForm.id } : {})
      });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      // 提交成功保存返回ID，再添加列表的编辑功能中有用
      this.$emit('ok', {
        ...values
      });
      this.form.resetFields();
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
      console.log(e);
    } finally {
      this.spinning = false;
    }
  }
  /**
   * form布局
   */
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 18,
        offset: 6
      }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };
}
